import React, { useMemo, useCallback, useState } from 'react';
import { useFocusIdx, useEditorProps } from 'easy-email-editor';
import { IconLink } from '@arco-design/web-react/icon';
import { SelectField, TextField } from '../../../components/Form';
import { Grid, Button, Popover } from '@arco-design/web-react';
import { MergeTags } from '@extensions';
import { IconFont } from 'easy-email-editor';
import { useField } from 'react-final-form';

export function Link() {
  const { focusIdx } = useFocusIdx();
  const { mergeTags } = useEditorProps();
  const { input: { onChange } } = useField(`${focusIdx}.attributes.href`);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const onMergeTagChange = useCallback((val: string) => {
    onChange(val);
    setPopoverVisible(false);
  }, [onChange]);

  return useMemo(() => {
    return (
      <Grid.Row>
        <Grid.Col span={11}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              prefix={<IconLink />}
              label={<span>{t('Href')}&nbsp;&nbsp;&nbsp;</span>}
              name={`${focusIdx}.attributes.href`}
              style={{ flex: 1 }}
            />
            {mergeTags && (
              <Popover
                trigger='click'
                popupVisible={popoverVisible}
                onVisibleChange={setPopoverVisible}
                content={<MergeTags value={`${focusIdx}.attributes.href`} onChange={onMergeTagChange} />}
              >
                <Button icon={<IconFont iconName='icon-merge-tags' />} />
              </Popover>
            )}
          </div>
        </Grid.Col>
        <Grid.Col offset={1} span={11}>
          <SelectField
            label={t('Target')}
            name={`${focusIdx}.attributes.target`}
            options={[
              {
                value: '',
                label: t('_self'),
              },
              {
                value: '_blank',
                label: t('_blank'),
              },
            ]}
          />
        </Grid.Col>
      </Grid.Row>
    );
  }, [focusIdx, mergeTags, onMergeTagChange, popoverVisible]);
}
